import { Spark } from "./Doodles";

// Slow cinematic marquee ribbon. bg/text props kept for API compat but the
// cinematic identity is enforced here.
export const Marquee = ({ items = [], bg, text, reverse = false, border = true }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`grain-dark overflow-hidden bg-charcoal marquee-mask ${border ? "border-y border-gold/25" : ""} py-4`}
      data-testid="editorial-marquee"
    >
      <div className={`flex w-max ${reverse ? "animate-marquee-rev" : "animate-marquee"} whitespace-nowrap`}>
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-6 px-6 font-display text-3xl uppercase tracking-tight text-metallic sm:text-4xl md:text-5xl">
            {item}
            <Spark className="h-4 w-4 shrink-0" fill="#C9A227" />
          </span>
        ))}
      </div>
    </div>
  );
};
